module.exports = __webpack_public_path__ + "static/img/zhuye.ca25a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhuye.png
// module id = Eb5X
// module chunks = 1